import React from 'react';
import { Hero } from './components/Hero';
import { ProblemValue } from './components/ProblemValue';
import { FeaturedRatings } from './components/FeaturedRatings';
import { TopLists } from './components/TopLists';
import { HowItWorks } from './components/HowItWorks';
import { StatsSection } from './components/StatsSection';
import { Footer } from './components/Footer';
import { Gamepad2 } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-pinnacle-dark text-white selection:bg-pinnacle-green selection:text-pinnacle-dark" data-id="element-0">
      {/* Simple Navigation Overlay */}
      <nav className="absolute top-0 left-0 right-0 z-50 py-6" data-id="element-1">
        <div className="container mx-auto px-4 flex items-center justify-between" data-id="element-2">
          <div className="flex items-center gap-2" data-id="element-3">
            <Gamepad2 className="w-8 h-8 text-pinnacle-green" data-id="element-4" />
            <span className="text-2xl font-bold text-white font-display tracking-tight" data-id="element-5">
              PinnacleGames
            </span>
          </div>
          <div className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-300" data-id="element-6">
            <a href="#" className="hover:text-white transition-colors" data-id="element-7">
              Reviews
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-8">
              Top Lists
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-9">
              News
            </a>
            <a href="#" className="px-4 py-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors" data-id="element-10">
              Sign In
            </a>
          </div>
        </div>
      </nav>

      <main data-id="element-11">
        <Hero data-id="element-12" />
        <ProblemValue data-id="element-13" />
        <FeaturedRatings data-id="element-14" />
        <TopLists data-id="element-15" />
        <HowItWorks data-id="element-16" />
        <StatsSection data-id="element-17" />
      </main>

      <Footer data-id="element-18" />
    </div>;
}